import moment from 'moment';
import type { MomentRange } from 'moment-range';
import { extendMoment } from 'moment-range';

import 'moment/dist/locale/de';
import 'moment/dist/locale/fr';

import { defaultLocale } from '@/helpers/i18n';

import 'moment/dist/locale/it';

const getMoment = (() => {
  let instance: MomentRange & typeof moment;

  return {
    getInstance: () => {
      if (!instance) {
        moment.locale(defaultLocale);
        instance = extendMoment(moment as unknown as Parameters<typeof extendMoment>[0]);
      }
      return instance;
    },
  };
})();

export function useMoment(): MomentRange & typeof moment {
  return getMoment.getInstance();
}
